var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnlargeIcnSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Enlarge-Icn-Small_svg__clip0_1918_3323)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 26C5.83 26 0 20.17 0 13S5.83 0 13 0s13 5.83 13 13-5.83 13-13 13zm0-24C6.93 2 2 6.93 2 13s4.93 11 11 11 11-4.93 11-11S19.07 2 13 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12H14V5.5h-2V12H5.5v2H12v6.5h2V14h6.5v-2z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Enlarge-Icn-Small_svg__clip0_1918_3323"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h26v26H0z"
  })))));
}

export default SvgEnlargeIcnSmall;